import { formatPrice } from '@/core/lib/utils/format-price'
import { useTranslations } from 'next-intl'
import { useOrderSummaryStore } from '../../store'
import { OrderStep } from '../../types/enums/order-step.enum'

export const OrderPrice = () => {
  const t = useTranslations()

  const {
    customerPrice,
    providerPrice,
    totalPrice,
    oldTotalPrice,
    step,
    isUpdate,
    currency,
    promoCodePrice,
  } = useOrderSummaryStore()
  const orderTotalPrice = promoCodePrice || totalPrice
  const priceDifference = orderTotalPrice - oldTotalPrice

  return (
    <div className='mt-3 flex flex-col gap-3'>
      {Boolean(isUpdate && (orderTotalPrice || providerPrice)) && (
        <>
          {step !== OrderStep.TRIP_INFO && (
            <div className='flex items-center justify-between text-sm font-medium'>
              <p>{t('trip.newPrice')}</p>
              <p className='text-red text-base font-medium'>
                {formatPrice(orderTotalPrice, currency)}
              </p>
            </div>
          )}

          <div>
            {customerPrice ? (
              <div
                className={`flex items-center justify-between text-sm font-medium`}
              >
                <p>{t('trip.customerPrice')}</p>
                <p className='text-red text-base font-medium'>
                  {formatPrice(customerPrice, currency)}
                </p>
              </div>
            ) : null}
            <div
              className={`flex items-center justify-between text-sm font-medium ${step === OrderStep.CREATE_TRIP && 'h-12'}`}
            >
              <p>{t('trip.paidAmount')}</p>
              <p className='text-red text-base font-medium'>
                {step !== OrderStep.TRIP_INFO ? '-' : ''}
                {formatPrice(providerPrice || oldTotalPrice, currency)}
              </p>
            </div>
          </div>
        </>
      )}

      {(step !== OrderStep.TRIP_INFO || !isUpdate) && (
        <div className='flex min-h-12 flex-col items-start justify-between @[16rem]:flex-row @[16rem]:items-center'>
          <div>
            <h4 className='text-sm font-medium'>
              {t('trip.totalPrice')}{' '}
              {isUpdate
                ? priceDifference >= 0
                  ? 'to be paid'
                  : 'to be refund'
                : ''}
            </h4>
            <p className='text-grey text-sm'>{t('trip.taxesIncluded')}</p>
          </div>
          <p dir='ltr' className='text-red text-xl font-medium'>
            {formatPrice(Math.abs(providerPrice || priceDifference), currency)}
          </p>
        </div>
      )}
    </div>
  )
}
